import React, { Component } from 'react';
import Select from 'react-select'
import { Link } from 'react-router-dom'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
// import Dropzone from 'react-dropzone';
// import Resizer from 'react-image-file-resizer';
import { DataToken } from '../../function/Format';

// koneksi
import { PostMain, GetMain, DeleteMain } from '../../function/Koneksi';

const formInput = {
	uuid: '',
	id_desa: '',
	url_api: '',
  };

class KonfigurasiDesa extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah Konfigurasi Desa",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',

			dataCari: {
				q: '',
			},
			sortOrder: '',
			loadingPreview: false,
			api: { uuid: '', url_api: '', url_api_web: '', url_website:'', lat: '', lang: '', id_desa: '', id_kecamatan: '', id_kabkota: '', id_provinsi: '' },
			data_desa: [],
			id_desa: '',


			id_provinsi: '',  
			dataProvinsi: [], 

			id_kabkota: '', 
			kabkotaData: [], 

			id_kecamatan: '',
			kecamatanData: [],

			id_kelurahan: '',
			kelurahanData: [],

			keldesData: [],

			name: '',

			level_desa: null,
			jenis_desa: null,
			get_jenis_app: '',
			jenis_app: [],
			get_jenis_app_perangkat: '',
			jenis_app_perangkat: [],
			masaAktif: '',
			akun: DataToken(localStorage.getItem('access_token')),
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		let link = "";
		
		if (params.page) {
			switch (params.page) {
				case ">>":
				  link =
					"?page=" +
					Math.ceil(
					  this.state.pagination.total / this.state.pagination.per_page
					);
				  break;
				case ">":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
				  break;
				case "<":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
				  break;
				case "<<":
				  link = "?page=1";
				  break;
				default:
				  link = "?page=" + params.page;
				  break;
			  }
		}

		if (this.state.dataCari && this.state.dataCari.q) {
			link += (link ? "&" : "?") + "q=" + this.state.dataCari.q;
		}
		
		if (this.state.sortOrder) {
			link += (link ? "&" : "?") + "sort_expired=" + this.state.sortOrder;
		}

		PostMain('main/web/list-api' + link, null, this.state.dataCari, (lihat) => {
			if (lihat.data && lihat.data.result) {
				const updatedData = lihat.data.result.data.map(item => {
					if (item.data_invoice && item.data_invoice.tgl_expired) {
						let tgl = Date.now();
						let set_tgl = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(tgl);
						let ex_tgl = set_tgl.split("/");
						let hari_ini = ex_tgl[2] + "-" + ex_tgl[0] + "-" + ex_tgl[1];
		
						let expired = item.data_invoice.tgl_expired;
						let ex_tgl_expired = expired.split(' ');
						let tgl_expired = ex_tgl_expired[0];
		
						let set_hari_ini = new Date(hari_ini);
						let set_expired = new Date(tgl_expired);
		
						let Difference_In_Time = set_expired.getTime() - set_hari_ini.getTime();
						let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
		
						item.masaAktif = Difference_In_Days === 0 ? 'nol' : Difference_In_Days;
		
						item.lisensi = set_hari_ini.getTime() <= set_expired.getTime();
					} else {
						item.masaAktif = '-';
						item.lisensi = false;
					}
					return item;
				});
				this.setState({ 
					data: updatedData, 
					pagination: lihat.data.result,
					loadingPreview: false,
				});
				this.pagination(lihat.data.result);
			} else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		// const data = this.state.pagination;
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			this.setState({ 
				dataCari:{
					q: e.target.value,
				}, 
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	// Making dynamic function
	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}
	
	ChangeProvinsi = (e) => {
		if (e) {
			this.setState({ id_provinsi: e.target.value });
			if (e.target.value === '') {
				this.setState({
					kabkotaData: [],
					kecamatanData: [],
					kelurahanData: [],
					keldesData: [],
				});
			}
			else {
				GetMain('master/web/provinsi/list-kabkota/' + e.target.value, null, (data) => {
					this.setState({
						kabkotaData: data.results,
					});
				});
			}
		}
		else {
			this.setState({ id_provinsi: '' });
		}
	}

	ChangeKabkota = (e) => {
		if (e) {
			this.setState({ id_kabkota: e.target.value });

			if (e.target.value === '') {
				this.setState({
					kecamatanData: [],
					kelurahanData: [],
					keldesData: [],
				});
			}
			else {
				GetMain('master/web/kabkota/list-kecamatan/' + e.target.value, null, (data) => {
					this.setState({
						kecamatanData: data.results
					});
				});
			}
		}
		else {
			this.setState({ id_kabkota: '' });
		}
	}

	ChangeKecamatan = (e) => {
		if (e) {
			this.setState({ id_kecamatan: e.target.value });

			if (e.target.value === '') {
				this.setState({
					kelurahanData: [],
					keldesData: [],
				});
			}
			else {
				GetMain('master/web/kecamatan/list-keldes/' + e.target.value, null, (data) => {
					this.setState({
						kelurahanData: data.results
					});
				});
			}
		}
		else {
			this.setState({ id_kecamatan: '' });
		}
	}

	ChangeKeldes = (e) => {
		if (e) {
			this.setState({ id_desa: e.target.value });

			if (e.target.value === '') {
				this.setState({
					keldesData: [],
					id_desa: '',
				});
			}
			else {
				let idnya = e.target.value;
				GetMain('master/web/keldes/find/' + e.target.value, null, (data) => {
					this.setState({
						keldesData: data.results,
						id_desa: idnya,
					});
				});
			}
		}
		else {
			this.setState({ id_desa: '' });
		}

	}

	onChangeSelect = (e, data) => {
		if (e) {
			switch (data) {
				case 'jenis_app':
					this.setState({ 
						get_jenis_app: { value: e.value, label: e.label }
					});
					break;
				case 'jenis_app_perangkat':
					this.setState({ 
						get_jenis_app_perangkat: { value: e.value, label: e.label }
					});
					break;
				case 'level_desa':
					this.setState({ 
						level_desa: { value: e.value, label: e.label } 
					});
					break;
				case 'jenis_desa':
					this.setState({ 
						jenis_desa: { value: e.value, label: e.label }
					});
					break;
			
				default:
					break;
			}
		} else {
			switch (data) {
				case 'jenis_app':
					this.setState({ jenis_app: '', get_jenis_app: '' });
					break;
					case 'jenis_app_perangkat':
						this.setState({ jenis_app_perangkat: '', get_jenis_app_perangkat: '' });
						break;
	
					case 'level_desa':
						this.setState({ level_desa: '' });
						break;
	
					case 'jenis_desa':
						this.setState({ jenis_desa: '' });
						break;
			
				default:
					break;
			}
		}
	}

	currencyFormatter = (cell) => {
		return new Intl.NumberFormat('id-ID', {
		  style: 'currency',
		  currency: 'IDR',
		}).format(cell);
	};
	
	// ================== simpan data ==================

	simpan = e => {
		e.preventDefault();
		this.setState({ loadingPreview: true })

		var id_desa = ''
		if (this.state.id_desa.value === undefined) {
			id_desa = this.state.id_desa;
		}
		else {
			id_desa = this.state.id_desa.value;
		}

		this.setState.btnForm = true;
		this.forceUpdate();

		if(!this.state.get_jenis_app || !this.state.get_jenis_app_perangkat){
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Konfigurasi Desa', 
				pesanAlert: 'Jenis Aplikasi dan Jenis Aplikasi Perangkat Wajib Diisi !' 
			});
		}
		else if(!this.state.level_desa){
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Konfigurasi Desa', 
				pesanAlert: 'Level Desa Wajib Diisi !' 
			});
		}
		else if(!this.state.jenis_desa){
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Konfigurasi Desa', 
				pesanAlert: 'Jenis Desa Wajib Diisi !' 
			});
		}
		else if(!this.state.id_desa){
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Konfigurasi Desa', 
				pesanAlert: 'Desa Wajib Diisi !' 
			});
		}
		else if(!document.getElementById("url_api").value || !document.getElementById("url_api_web").value || !document.getElementById("url_website").value || !document.getElementById("lat").value || !document.getElementById("lang").value){
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Konfigurasi Desa', 
				pesanAlert: 'Data Tidak Boleh Kosong !' 
			});
		}
		else{

			let addListAPI = {
				uuid: this.state.api.uuid,
				id_desa: id_desa,
				url_api: document.getElementById("url_api").value,
				url_api_web: document.getElementById("url_api_web").value,
				lat: document.getElementById("lat").value,
				lang: document.getElementById("lang").value,
				level_desa: this.state.level_desa.value,
				jenis_desa: this.state.jenis_desa.value,
				jenis_app: this.state.get_jenis_app.value,
				jenis_app_perangkat: this.state.get_jenis_app_perangkat.value,
				url_website: document.getElementById("url_website").value,
			};

			let psn = '';
			let resstat = 204;
			let metode = "create";
			if (addListAPI.uuid === '') {
				psn = "Tambah";
				resstat = 200;
				addListAPI.uuid = null;

			}
			else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			PostMain('main/web/list-api/' + metode, addListAPI.uuid, addListAPI, (res) => {
				this.setState({ 
					status:{
						...this.state.status,
						btnForm: false,
						form: false,
					},
				});
				this.forceUpdate();
				if (res.status === resstat) {
					this.setState({ 
						loadingPreview: false,
						show: true, 
						basicType: 'success', 
						basicTitle: 'Data Konfigurasi Desa', 
						pesanAlert: 'Berhasil ' + psn + ' Data' 
					});
				}
				else {
					this.setState({ 
						loadingPreview: false,
						show: true, 
						basicType: 'danger', 
						basicTitle: 'Data Konfigurasi Desa', 
						pesanAlert: 'Gagal ' + psn + ' Data' 
					});
				}
				this.componentDidMount();
			});
		}
	};

	ubahData = id => {

		this.setState({
			...this.state.status,
			btnAksi: true,
			judul: "Ubah Data Konfigurasi Desa ",
			loadingPreview: true,
		});

		this.forceUpdate();

		GetMain('main/web/list-api/find', id, (data) => {
			if (data.result) {
				this.setState({
					api: {
						uuid: data.result.uuid,
						id_desa: data.result.id_desa,
						id_kecamatan: data.result.data_desa.id_kecamatan,
						id_kabkota: data.result.data_desa.data_kecamatan.id_kabkota,
						url_api: data.result.url_api,
						url_api_web: data.result.url_api_web,
						url_website: data.result.url_website,
						lat: data.result.lat,
						lang: data.result.lang,
					},
					id_desa: { value: data.result.id_desa, label: data.result.data_desa.nama },
					id_kecamatan: { value: data.result.data_desa.id_kecamatan, label: data.result.data_desa.data_kecamatan.nama },
					id_kabkota: { value: data.result.data_desa.data_kecamatan.id_kabkota, label: data.result.data_desa.data_kecamatan.data_kabkota.nama },
					id_provinsi: { value: data.result.data_desa.data_kecamatan.data_kabkota.id_provinsi, label: data.result.data_desa.data_kecamatan.data_kabkota.data_provinsi.nama },
					get_jenis_app: { value: data.result.get_jenis_app.uuid, label: data.result.get_jenis_app.nama },
					get_jenis_app_perangkat: { value: data.result.get_jenis_app_perangkat.uuid, label: data.result.get_jenis_app_perangkat.nama },
					level_desa: { value: data.result.level_desa, label: data.result.level_desa },
					jenis_desa: { value: data.result.jenis_desa, label: data.result.jenis_desa },

				});

				GetMain('master/web/provinsi/list-kabkota/' + data.result.data_desa.data_kecamatan.data_kabkota.id_provinsi, null, (data_kota) => {
					this.setState({
						kabkotaData: data_kota.results,
					});

					GetMain('master/web/kabkota/list-kecamatan/' + data.result.data_desa.data_kecamatan.id_kabkota, null, (data_kecamatan) => {
						this.setState({
							kecamatanData: data_kecamatan.results
						});

						GetMain('master/web/kecamatan/list-keldes/' + data.result.data_desa.id_kecamatan, null, (data_kelurahan) => {
							this.setState({
								kelurahanData: data_kelurahan.results
							});
						});
					});
				});

				this.setState.level_desa = {
					value: data.result.level_desa, label: (
						data.result.level_desa === 'Desa' ? 'Desa'
							: data.result.level_desa === 'Kelurahan' ? 'Kelurahan'
								: 'Nagari'
					)
				};
				this.setState.jenis_desa = {
					value: data.result.jenis_desa, label: (
						data.result.jenis_desa === 'Berbayar' ? 'Berbayar'
							: data.result.jenis_desa === 'Uji Coba' ? 'Uji Coba'
								: 'Demo'
					)
				};
			}
			this.setState({
				...this.state.status,
				btnAksi: false,
				loadingPreview: false,
			});
			this.forceUpdate();
			this.bukaForm('edit');
		});
	};

	konfirmHapus = (id) => {
		this.setState({
			alert: (
				<SweetAlert
					showCancel
					confirmBtnText="Hapus"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="success"
					type="danger"
					title="Yakin ingin hapus data ?"
					onCancel={this.hideAlert}
					onConfirm={() => this.hapusData(id)}
				>
					Proses ini tidak dapat dibatalkan!
				</SweetAlert>
			)
		});
	}

	hapusData = (id) => {
		this.hideAlert();
		let psn = "Hapus";
		this.setState({
			loadingPreview: true
		})
		DeleteMain('main/web/list-api/delete', id, (res) => {
			if (res === 200) {
				this.setState({ 
					loadingPreview: false,
					show: true, 
					basicType: 'success', 
					basicTitle: 'Data Konfigurasi Desa', 
					pesanAlert: 'Berhasil ' + psn + ' Data' 
				});
			}
			else {
				this.setState({ 
					loadingPreview: false, 
					show: true, 
					basicType: 'danger', 
					basicTitle: 'Data Konfigurasi Desa', 
					pesanAlert: 'Gagal ' + psn + ' Data' 
				});
			}
			this.componentDidMount();
		})
	}

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				api: {
					...this.state.api,
					uuid: '',
					url_api:'',
					url_api_web:'',
					url_website:'',
					lat:'',
					lang:'',
				},
				id_desa: '',
				id_provinsi: '',
				id_kabkota: '',
				id_kecamatan: '',
				level_desa: '',
				jenis_desa: '',
				kabkotaData: [],
				kecamatanData: [],
				kelurahanData: [],
				get_jenis_app: '',
				get_jenis_app_perangkat: '',
			})
		}

		this.setState({
			status:{
				...this.state.status,
				form: true,
			}
		})
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	getFilePreview = (data) => {
			
		const fileParse = data.file;
		// const imageUrl = fileParse.thumbnail;
		const fileUrl = fileParse.url;
		const fileName = fileParse.filename;
		const fileExtension = fileName.split('.').pop().toLowerCase();
	
		switch (fileExtension) {
			case 'png':
			case 'jpg':
			case 'jpeg':
		  	case 'pdf':
			case 'xlsx':
			case 'xls':
			case 'doc':
			case 'docx':
			return <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download File</a>;
		  
			default:
				return (
				<div>
					<p>Format file ini tidak didukung. Silahkan di Download <a href={fileUrl}>Download</a>.</p>
				</div>
			);
		}
	}

	tombolAksi = (cell, row) => {
		return (
			<>
				{this.state.akun.sub.data_role.nama !== "Admin" ? (
					<Link to={{ pathname: "/main/list-invoice-pembelian", state: row }}>
						<Button size="xs" color="primary" className="btn-icon" disabled={this.state.status.btnAksi}><i className="fa fa-eye"></i></Button> &nbsp;
					</Link>
				) : (
					<Link to={{ pathname: "/main/invoice-pembelian", state: row }}>
						<Button size="xs" color="primary" className="btn-icon" disabled={this.state.status.btnAksi}><i className="fa fa-eye"></i></Button> &nbsp;
					</Link>
				)}
				{this.state.akun.sub.data_role.nama === "Admin" && (
					<>
						<Button size="xs" color="success" className="btn-icon" onClick={() => this.ubahData(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;
						<Button size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-trash"></i></Button>
					</>
				)}
			</>
		)
	}

	componentDidMount() {
		this.fetch({ page: null, where: [] });
		const params = new URLSearchParams(this.props.location.search);
		const sort = params.get('sort');

		if (sort) {
			this.setState({ sortOrder: sort }, () => this.fetch());
		} else {
			this.fetch();
		}

		GetMain('master/web/provinsi/list-provinsi', null, (data) => {
			
			this.setState({
				dataProvinsi: data.results
			});
		});

		GetMain('main/web/jenis-aplikasi/list', null, (data) => {
			if (data) {
				let jenis_app = [];
				data.result.forEach(dt => {
					jenis_app.push({ value: dt.uuid, label: dt.nama });
				});
				this.setState({ jenis_app });
			}
			
		});

		GetMain('main/web/jenis-aplikasi-perangkat/list', null, (data) => {
			if (data) {
				let jenis_app_perangkat = [];
				data.result.forEach(dt => {
					jenis_app_perangkat.push({ value: dt.uuid, label: dt.nama });
				});
				this.setState({ jenis_app_perangkat });
			}
		});
	}
	
	render() {
		var data = this.state.data;

		let field = this.state.akun.sub.data_role.nama !== "Admin";
	
		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'data_desa',
				text: 'Desa',
				headerAlign: 'center',
				sort: true,
				formatter: (cell, obj) => {
					if(obj.data_desa){
					  return (obj.data_desa.nama+' - '+obj.data_desa.id);
					}
					else{
					  return ('-');
					}
				  },
			},
			{
				dataField: 'data_desa',
				text: 'Kecamatan',
				headerAlign: 'center',
				sort: true,
				formatter: (cell, obj) => {
					if(obj.data_desa && obj.data_desa.data_kecamatan){
					  return (obj.data_desa.data_kecamatan.nama);
					}
					else{
					  return ('-');
					}
				},
			},
			{
				dataField: 'data_desa',
				text: 'Kab/Kota',
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {
					if(obj.data_desa && obj.data_desa.data_kecamatan && obj.data_desa.data_kecamatan.data_kabkota){
					  return (obj.data_desa.data_kecamatan.data_kabkota.nama);
					}
					else{
					  return ('-');
					}
				},
			},
			{
				dataField: "data_desa",
				text: "Provinsi",
				sort: true,
				formatter: (cell, obj) => {
				  if(obj.data_desa && obj.data_desa.data_kecamatan && obj.data_desa.data_kecamatan.data_kabkota && obj.data_desa.data_kecamatan.data_kabkota.data_provinsi){
					return (obj.data_desa.data_kecamatan.data_kabkota.data_provinsi.nama);
				  }
				  else{
					return ('-');
				  }
				},
			},
			{
				dataField: 'get_jenis_app.nama',
				text: 'Jenis Aplikasi',
				sort: true,
			},
			...field ? [] : [
				{
					dataField: 'url_api_web',
					text: 'Url API Web',
					sort: true,
				},
				{
					dataField: 'url_website',
					text: 'Url Website',
					sort: true,
				},
				{
					dataField: 'get_jenis_app_perangkat.nama',
					text: 'Jenis Aplikasi Perangkat',
					sort: true,
				},
				{
					dataField: 'jenis_desa',
					text: 'Jenis Desa',
					sort: true,
				},
			],
			{
				dataField: "masaAktif",
				text: "Masa Aktif",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {
					let countHari = obj.masaAktif;
					let layanan = countHari + " Hari" ? countHari + " Hari" : '-';
					let colorStyle = { color: 'red' };
					
					if (countHari > 30) {
						colorStyle = { color: 'green' };
						layanan = countHari +" Hari";
					} else if (countHari >= 7) {
						colorStyle = { color: 'orange' };
					} else if (countHari < 1) {
						// layanan = "Layanan Telah Berakhir";
						layanan = countHari +" Hari";
					}

					return (
						<span style={colorStyle}>
							{layanan}
						</span>
					);
				},
			},
			{
				dataField: "data_invoice.tgl_expired",
				text: "Tanggal Berakhir",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {					
				let plainTime = '-';
					if (obj.data_invoice && obj.data_invoice.tgl_expired) {
						let date = new Date(obj.data_invoice.tgl_expired)
						date = date.toLocaleString('id-ID')
						
						const datetime = date.split(' ')
	
						date = datetime[0]
	
						const splitDate = date.split('/')
	
						const list_bulan = [
							'Januari',
							'Februari',
							'Maret',
							'April',
							'Mei',
							'Juni',
							'Juli',
							'Agustus',
							'September',
							'Oktober',
							'November',
							'Desember'
						];

						plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]} `;
					}

					return plainTime
				}
			},
			{
				dataField: "data_invoice.sisa_bayar",
				text: "Status Pembayaran",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {
					if (obj.data_invoice && obj.data_invoice.sisa_bayar !== undefined) {
						let sisa_bayar = obj.data_invoice.sisa_bayar;
						let status_pembayaran = '';
						let colorStyle = {};
						
						if (sisa_bayar === 0) {
							colorStyle = { color: 'green' };
							status_pembayaran = "Lunas";
						} else {
							colorStyle = { color: 'red' };
							status_pembayaran = "Belum Lunas";
						}

						return (
							<span style={colorStyle}>
								{status_pembayaran}
							</span>
						);
					}
					return <span style={{ color: 'gray' }}>Data Tidak Tersedia</span>;
				},
			},
			{
				dataField: "data_invoice.sisa_bayar",
				text: "Sisa Bayar",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: this.currencyFormatter
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="Konfigurasi Desa" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-5">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari.q}
												onKeyPress={this.cariData}
											/>
										</div>
										<div className="col-sm-4">
											<select 
												className="form-control"
												value={this.state.sortOrder || ''}
												onChange={(e) => {
													this.setState({ sortOrder: e.target.value }, () => this.fetch());
												}}
											>
												<option value="">Pilih Sorting Data</option>
												<option value="asc">Masa Aktif Akan Berakhir</option>
												<option value="desc">Masa Aktif Masih Lama</option>
											</select>
										</div>
										<div className="col-sm-3 text-right">
											{this.state.akun.sub.data_role.nama === "Admin"
											?
												<Button 
													size="sm" 
													color="success" 
													className="btn-square" 
													onClick={() => {
														this.setState({ 
															judul: "Tambah Konfigurasi Desa", 
															dt: formInput,
														}); 
														this.bukaForm('tambah'); 
													}}
												>
													Tambah Data
												</Button>
											: ''}
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "70%" } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.api.uuid} />
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Provinsi</Label>
								<Col sm='9'>
									<select
										className="form-control"
										name="id_provinsi"
										value={this.state.id_provinsi.value}
										onChange={this.ChangeProvinsi}
									>
										<option value="">Pilih Provinsi</option>
										{this.state.dataProvinsi.map((e, key) => {
											return <option key={key} value={e.id}>{e.nama}</option>;
										})}
									</select>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Kabupaten/Kota</Label>
								<Col sm='9'>
									<select
										className="form-control slct"
										name="id_kabkota"
										value={this.state.id_kabkota.value}
										onChange={this.ChangeKabkota}
									>
										<option value="">Pilih Kabupaten/Kota</option>
										{this.state.kabkotaData.map((e, key) => {
											return <option key={key} value={e.id}>{e.nama}</option>;
										})}
									</select>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Kecamatan</Label>
								<Col sm='9'>
									<select
										className="form-control slct"
										name="id_kecamatan"
										value={this.state.id_kecamatan.value}
										onChange={this.ChangeKecamatan}
									>
										<option value="">Pilih Kecamatan</option>
										{this.state.kecamatanData.map((e, key) => {
											return <option key={key} value={e.id}>{e.nama}</option>;
										})}
									</select>
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Kelurahan/Desa</Label>
								<Col sm='9'>
									<select
										className="form-control slct"
										name="id_desa"
										value={this.state.id_desa.value}
										onChange={this.ChangeKeldes}
									>
										<option value="">Pilih Kelurahan/Desa</option>
										{this.state.kelurahanData.map((e, key) => {
											return <option key={key} value={e.id}>{e.nama}</option>;
										})}
									</select>
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">URL API Mobile</Label>
								<Col sm='9'>
									<input className="form-control" id="url_api" type="text" placeholder="URL API Mobile" defaultValue={this.state.api.url_api} required />
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">URL API Web</Label>
								<Col sm='9'>
									<input className="form-control" id="url_api_web" type="text" placeholder="URL API Web" defaultValue={this.state.api.url_api_web} required />
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">URL Website Desa</Label>
								<Col sm='9'>
									<input className="form-control" id="url_website" type="text" placeholder="URL Website" defaultValue={this.state.api.url_website} required />
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Latitude</Label>
								<Col sm='9'>
									<input type="text" id="lat" className="form-control" defaultValue={this.state.api.lat} required />
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Langitude</Label>
								<Col sm='9'>
									<input type="text" id="lang" className="form-control" defaultValue={this.state.api.lang} required/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Aplikasi</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={(e) => {
											this.onChangeSelect(e, 'jenis_app');
										}}
										defaultValue={this.state.get_jenis_app}
										value={this.state.get_jenis_app}
										name="Agama"
										options={this.state.jenis_app}
										placeholder="Pilih Jenis Aplikasi"
										isClearable
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Aplikasi Perangkat</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={(e) => {
											this.onChangeSelect(e, 'jenis_app_perangkat');
										}}
										defaultValue={this.state.get_jenis_app_perangkat}
										value={this.state.get_jenis_app_perangkat}
										name="jenis_app_perangkat"
										options={this.state.jenis_app_perangkat}
										placeholder="Pilih Jenis Aplikasi Perangkat"
										isClearable
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Level Desa</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={(e) => this.onChangeSelect(e, 'level_desa')}
										value={this.state.level_desa}
										name="level_desa"
										options={[
											{ value: 'Desa', label: 'Desa' },
											{ value: 'Kelurahan', label: 'Kelurahan' },
											{ value: 'Nagari', label: 'Nagari' },
										]}
										placeholder="Pilih Level Desa"
										isClearable
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Desa</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={(e) => this.onChangeSelect(e, 'jenis_desa')}
										value={this.state.jenis_desa}
										name="jenis_desa"
										options={[
											{ value: 'Berbayar', label: 'Berbayar' },
											{ value: 'Uji Coba', label: 'Uji Coba' },
											{ value: 'Demo', label: 'Demo' },
										]}
										placeholder="Pilih Jenis Desa"
										isClearable
									/>
								</Col>
							</FormGroup>

						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default KonfigurasiDesa;
